import logger from "./Log";



var en = {
    SelPlace:"Select this place?",
    Save:"Saved."
};

var tr = {
    SelPlace:"Burayı seçmek istiyor musunuz?",
    Save:"ذخیره شد"
};

var fr = {
    SelPlace:"Burayı seçmek istiyor musunuz?",
    Save:"ذخیره شد",
    invalid_grant:'یوزرنیم یا پسورد اشتباه است',
    error_connction:'خطا در برقرای ارتباط با سرور.اینترنت خود را چک کنید',
    about_us:"درباره بیت کالا",
    Contribution:"همکاری با ما",
    faqs:"سوالات متداول",
    contact_us:"ارتباط با ما",
    telegram_channel:"کانال تلگرام",
    register:"عضویت",
    registerCom1:"اگر در بیت کالا حساب ندارید، ثبت نام کنید:",
    registerCom2:"اگر در بیت کالا حساب کاربری دارید، وارد شوید:",
    login:"ورود",
    main_page:"صفحه اصلی",
    products:"محصولات",
    all_products:"همه محصولات", 
    newest:"جدیدترین",
    reminder:"یادآوری",
    discussion:"بحث و گفتگو",
    articles:"مقالات",
    bitkala_cast:"بیت کالا کست",
    projects:"پروژه ها",
    webDesign:"طراحی وب سایت",
    webApp:"وب اپلیکیشن",
    mobileApp:"موبایل اپلیکیشن",
    services:"خدمات",
};

var frHoney = {
    SelPlace:"Burayı seçmek istiyor musunuz?",
    Save:"ذخیره شد",
    invalid_grant:'یوزرنیم یا پسورد اشتباه است',
    error_connction:'خطا در برقرای ارتباط با سرور.اینترنت خود را چک کنید',
    about_us:"درباره بیت کالا",
    Contribution:"همکاری با ما",
    faqs:"سوالات متداول",
    contact_us:"ارتباط با ما",
    telegram_channel:"کانال تلگرام",
    register:"عضویت",
    registerCom1:"اگر در هانی کده حساب ندارید، ثبت نام کنید:",
    registerCom2:"اگر در هانی کده حساب کاربری دارید، وارد شوید :",
    login:"ورود",
    main_page:"صفحه اصلی",  
    products:"محصولات",
    all_products:"همه محصولات", 
    newest:"جدیدترین",
    reminder:"یادآوری",
    discussion:"بحث و گفتگو",
    articles:"مقالات",
    bitkala_cast:"بیت کالا کست",
    projects:"پروژه ها",
    webDesign:"طراحی وب سایت",
    webApp:"وب اپلیکیشن",
    mobileApp:"موبایل اپلیکیشن",
    services:"خدمات",
};

const language = "fr"

const lang =new function ()
{
    var lang = language;
    var __construct = function() {
        if (eval('typeof ' + lang) == 'undefined')
        {
            lang = "en";
        }
        return;
    }()

    this.getStr = function(str, defaultStr) {

        if (str === '')
          return '';
          try {
            var retStr = eval('eval(lang).' + str);
          } catch (error) {
           return str;
          }
       
        if (typeof retStr != 'undefined')
        {
            return retStr;
        } else {
            if (typeof defaultStr != 'undefined')
            {
                return defaultStr;
            } else {
              
                return str;
            }
        }
    }
}

export default lang;